export const PUZZLE_CONFIG = {
  sizes: {
    small: 3,
    medium: 5,
    large: 7
  },
  dimensions: {
    3: { width: 400, height: 400, backgroundSize: '300% 300%' },
    4: { width: 400, height: 400, backgroundSize: '400% 400%' },
    5: { width: 400, height: 400, backgroundSize: '500% 500%' }
    
  },
  defaultSize: 3, // 3x3으로 시작
  imageUrl: '/puzzle.webp',
  animationDuration: 150,
  completionDelay: 300,
  videoUrl: 'https://www.youtube.com/watch?v=nuhslQ_1kOk'
};

export const GAME_STATES = {
  PLAYING: 'playing',
  COMPLETE: 'complete',
  PAUSED: 'paused'
}; 